import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { AnalyticsStore } from 'bernie-core';

import { NoFlightsFoundMessaging } from '.';
import { ErrorStore, SortFilterStore } from 'stores';
import { FailedRequestMessaging, NoApiResponse } from 'components/shared/error-messages';

export interface ErrorListingsProps {
  errorStore?: ErrorStore;
  sortFilterStore?: SortFilterStore;
  analytics?: AnalyticsStore;
}

@inject('errorStore', 'sortFilterStore', 'analytics')
@observer
export class ErrorListings extends React.Component<ErrorListingsProps> {
  public componentDidMount() {
    const { errorStore, analytics } = this.props;
    const { clientFetchFailure, noListingMessaging } = errorStore;

    if (
      clientFetchFailure ||
      (noListingMessaging && noListingMessaging.__typename !== 'FlightsNoFlightsFoundWithFilterMessaging')
    ) {
      analytics.markPageUsable();
    }
  }

  public render() {
    const { errorStore } = this.props;
    const { clientFetchFailure, noListingMessaging, failedRequestMessaging } = errorStore;

    if (clientFetchFailure && failedRequestMessaging) {
      return <FailedRequestMessaging flightsActionableErrorMessaging={failedRequestMessaging} />;
    }

    if (clientFetchFailure) {
      return <NoApiResponse />;
    }

    if (noListingMessaging) {
      switch (noListingMessaging.__typename) {
        case 'FlightsNoFlightsFoundMessaging':
        case 'FlightsNoFlightsFoundWithFilterMessaging':
          return <NoFlightsFoundMessaging noListingMessaging={noListingMessaging} />;
        default:
          // no-op
          break;
      }
    }

    return null;
  }
}

export default ErrorListings;
